import {
	getPresetsAsyncAction,
	createPresetItemAsyncAction,
	deletePresetItemAsyncAction,
	getTournamentsAsyncAction,
	getTournamentAsyncAction,
	updateTournamentStatusAsyncAction,
	getTournamentJoinedAsyncAction,
	deleteTournamentAsyncAction,
	exportTournamentsDataAsyncAction,
	getResultsAsyncAction,
	updateTournamentResultsAsyncAction,
	withdrawTournamentAsyncAction,
	joinTournamentAsyncAction,
} from "./tournamentActions";
import { createEpic, createDownloadEpic } from "../helpers";

export const getPresetsEpic = createEpic(
	getPresetsAsyncAction,
	"tournament",
	"getPresets",
	true
);

export const getResultsEpic = createEpic(
	getResultsAsyncAction,
	"tournament",
	"getResults",
	true
);

export const createPresetItemEpic = createEpic(
	createPresetItemAsyncAction,
	"tournament",
	"createPresetItem",
	true
);

export const deletePresetItemEpic = createEpic(
	deletePresetItemAsyncAction,
	"tournament",
	"deletePresetItem",
	true
);

export const getTournamentsEpic = createEpic(
	getTournamentsAsyncAction,
	"tournament",
	"getTournaments",
	true
);

export const getTournamentEpic = createEpic(
	getTournamentAsyncAction,
	"tournament",
	"getDetail",
	true
);

export const updateTournamentResultsEpic = createEpic(
	updateTournamentResultsAsyncAction,
	"tournament",
	"updateResults",
	true
);

export const joinTournamentEpic = createEpic(
	joinTournamentAsyncAction,
	"tournament",
	"joinTournament",
	true
);

export const withdrawTournamentEpic = createEpic(
	withdrawTournamentAsyncAction,
	"tournament",
	"withdrawTournament",
	true
);

export const updateTournamentStatusEpic = createEpic(
	updateTournamentStatusAsyncAction,
	"tournament",
	"updateStatus",
	true
);

export const getTournamentJoinedEpic = createEpic(
	getTournamentJoinedAsyncAction,
	"tournament",
	"getTournamentJoined",
	true
);

export const deleteTournamentEpic = createEpic(
	deleteTournamentAsyncAction,
	"tournament",
	"deleteTournament",
	true
);

export const exportTournamentsEpic = createDownloadEpic(
	exportTournamentsDataAsyncAction,
	"tournament",
	"exportTournaments",
	true,
	"tournaments"
);
